import { Schema } from '@core/data/dto/schema';
import { getLocalMomentFromUtc } from '@core/utils/date-time';
import { FORMAT } from '@core/utils/formats';


export const DeliveryOrderManagerNoteSchema = {
    note: Schema.String,
    created_at: {
        map: 'createdAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    created_by: Schema.String,
};
